import isset from 'isset';
import { isEqual } from 'lodash';

export default {
  get isset() {
    return isset;
  },
  get isString() {
    return (string) => typeof string === 'string';
  },
  get isNum() {
    return (string) => !Number.isNaN(Number(string)) && Number.isFinite(parseInt(string, 10));
  },
  get isEmptyArray() {
    return (value) => Array.isArray(value) && value.length === 0;
  },
  get formatDollarAmount() {
    return (value) => {
      if (!value) {
        return '$0.00';
      }
      return `$${value.toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
    };
  },
  get formatNumber() {
    return (value) => {
      if (!value) {
        return '0.00';
      }
      return value.toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,');
    };
  },
  get checkNumber() {
    return (evt) => {
      evt = (evt) || window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    };
  },
  get formatDuration() {
    return (durationInMinutes, glue = ' ', useShortUnits = false) => {
      // When resolution is empty we should allow the '---'
      if (durationInMinutes === '---') {
        return durationInMinutes;
      }
      if (Number.isNaN(durationInMinutes)) {
        return ' ';
      }

      if (durationInMinutes === 0) {
        return ' ';
      }

      const durationInHours = durationInMinutes / 60;
      const hours = Math.floor(Math.abs(durationInHours));
      const minutes = Math.ceil(Math.abs(durationInMinutes % 60));
      let hoursUnit;
      let minutesUnit;

      if (useShortUnits) {
        hoursUnit = 'h';
        minutesUnit = 'm';
      } else {
        hoursUnit = `${hours === 1 ? ' hr' : ' hrs'}`;
        minutesUnit = `${minutes === 1 ? ' min' : ' mins'}`;
      }

      const hoursText = hours === 0 ? '' : `${hours}${hoursUnit}`;
      const minutesText = minutes === 0 ? '' : `${minutes}${minutesUnit}`;
      const sign = Math.sign(durationInMinutes) < 0 ? '-' : '';

      // Remove additional space when there is no hour
      if (hours === 0) {
        glue = '';
      }

      if (minutes === 0) {
        return `${sign}${hoursText}`;
      }

      return `${sign}${hoursText}${glue}${minutesText}`;
    };
  },
  get getUpdatedObjectKeyValue() {
    return (newObject = {}, oldObject = {}) => {
      let newValue = null;
      let oldValue = null;

      const objDifferenceKeys = Object.keys({ ...newObject, ...oldObject })
        .filter((key) => !isEqual(newObject[key], oldObject[key]));

      const changedKey = objDifferenceKeys.length > 0 ? objDifferenceKeys[0] : null;

      if (changedKey !== null) {
        newValue = newObject[changedKey] ?? null;
        oldValue = oldObject[changedKey] ?? null;
      }

      return {
        changedKey,
        newValue,
        oldValue,
      };
    };
  },

  get formatTimezone() {
    return (timezone) => {
      return `US/${timezone}`;
    };
  },

  get sanitizeValue() {
    return (value, convertMap, defaultValue = null) => {
      if (convertMap.has(value)) {
        return convertMap.get(value);
      }
      return defaultValue;
    };
  },
  get timezoneAbbrWithoutDst() {
    return (abbrName) => {
      switch (abbrName.toLowerCase()) {
        case 'ast':
        case 'adt':
          return 'AT';
        case 'est':
        case 'edt':
          return 'ET';
        case 'cst':
        case 'cdt':
          return 'CT';
        case 'mst':
        case 'mdt':
          return 'MT';
        case 'pst':
        case 'pdt':
          return 'PT';
        default:
          return abbrName;
      }
    };
  },
  get formatSubmittedTimes() {
    return (startDate, endDate) => {
      if (startDate && endDate) {
        const startTime = moment.parseZone(startDate).format('HH:mm');
        const endTime = moment.parseZone(endDate).format('HH:mm');
        return `${startTime} - ${endTime}`;
      }
      return '-';
    };
  },
  get formatWaitingTimeInHours() {
    return (sinceUtcDate) => {
      if (sinceUtcDate) {
        const age = moment.utc().diff(sinceUtcDate, 'hours');
        let cssClass = '';
        let icon = '';
        if (age > 8) {
          cssClass = 'error--text';
          icon = '<i class="v-icon notranslate mdi mdi-alarm" style="font-size:14px"></i>';
        }
        return {
          html: `<span class="${cssClass}">${icon} ${age} hours</span>`,
        };
      }
      return '-';
    };
  },
  get loseReference() {
    return (object) => {
      return JSON.parse(JSON.stringify(object));
    };
  },
};
